// extracted by mini-css-extract-plugin
module.exports = {"offerCallNumber":"#fcbe60"};